import axios from 'axios';

// Auto-detect API URL based on where the app is loaded from.
// This avoids needing a .env.production file in git (security)
// and works automatically on any domain we host on.
const getApiUrl = () => {
  // Explicit override via env var — used if the user wants to point at a different API
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;

  // Local development (laptop): React on port 3000, API on port 5000
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') {
    return 'http://localhost:5000/api';
  }

  // Production / any other domain: React and API share the same origin
  // e.g. https://smartshiftpay.com → https://smartshiftpay.com/api
  return `${window.location.origin}/api`;
};

const api = axios.create({
  baseURL: getApiUrl(),
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
}, (error) => Promise.reject(error));

api.interceptors.response.use((response) => response, (error) => {
  if (error.response?.status === 401) {
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
    if (window.location.pathname !== '/signin') window.location.href = '/signin';
  }
  return Promise.reject(error);
});

export default api;